import { v4 as uuidv4 } from 'uuid';

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionStorage.setItem('sessionId', uuidv4().toUpperCase()); //uppercase for sql
    sessionId = sessionStorage.getItem('sessionId');
  }
  return sessionId;
};
